import router from "./router";
import store from "./store";

import NProgress from "nprogress"; //进度条
import "nprogress/nprogress.css"; //进度条样式
import { getToken } from "@/utils/auth"; // 从cookie中获取token
import getPageTitle from "@/utils/get-page-title";
import settings from "./settings";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login","/flvplayer","/hlsplayer","/privacy"]; // 白名单，不用登录
 
router.beforeEach(async (to, from, next) => {
  // console.log("to.path", to.path);
  // console.log("当前时间", Date.now());
 settings.routeStartTime[to.path] = Date.now()
  NProgress.start();

  //替换当前页面的标题
  document.title = getPageTitle(to.meta.title);

  //判断是否登录了
  const hasToken = getToken();
// console.log(hasToken)
  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      //路由判断
        // console.log("to", to);
      
      const hasRoutes =
        store.getters.permission_routes &&
        store.getters.permission_routes.length > 0;
          // console.log( store.getters.permission_routes);
       
      if (hasRoutes) {
        next();
      } else {
        //没有路由，需要重新组织
        const { menus } = await store.dispatch("user/getMenuTrees");
 // console.log( menus); 
        const accessRoutes = await store.dispatch(
          "permission/generateRoutes",
          menus
        );
  // console.log( accessRoutes);
        // 动态添加路由
        router.addRoutes(accessRoutes);

        // hack method to ensure that addRoutes is complete
        // set the replace: true, so the navigation will not leave a history record
        next({ ...to, replace: true });
      }
    }
  } else {
    //未登录
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      //去登录页面
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
